import { LineChart } from '@mui/x-charts/LineChart';
import ChartCard from '../../analytics/ChartCard';
import { ServiceUptimeDataPoint } from '../../../../types/admin';

interface ServiceUptimeChartProps {
  data: ServiceUptimeDataPoint[];
  loading?: boolean;
}

export default function ServiceUptimeChart({ data, loading }: ServiceUptimeChartProps) {
  // Group data by service
  const serviceNames = Array.from(new Set(data.map((d) => d.service)));
  const timestamps = Array.from(new Set(data.map((d) => new Date(d.timestamp))));

  const series = serviceNames.map((serviceName) => {
    const serviceData = data.filter((d) => d.service === serviceName);
    return {
      data: serviceData.map((d) => d.uptime),
      label: serviceName,
      showMark: false,
    };
  });

  return (
    <ChartCard title="Service Uptime (24h)" subtitle="Uptime percentage by service" loading={loading} height={400}>
      <LineChart
        xAxis={[
          {
            data: timestamps,
            scaleType: 'time',
            valueFormatter: (date) =>
              new Date(date).toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              }),
          },
        ]}
        yAxis={[
          {
            label: 'Uptime (%)',
            min: 95,
            max: 100,
          },
        ]}
        series={series}
        grid={{ vertical: false, horizontal: true }}
        sx={{
          '& .MuiLineElement-root': {
            strokeWidth: 2,
          },
        }}
      />
    </ChartCard>
  );
}
